import { render } from "./Doclist.vue?vue&type=template&id=58b954c4&ts=true"
import script from "./Doclist.vue?vue&type=script&lang=ts"
export * from "./Doclist.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__